import React from "react";
import type { JSX } from "react";

interface CheckboxLabelProps {
  name: string;
  checked: boolean;
  onChange: React.FormEventHandler<HTMLInputElement>;
  label: string;
  whiteSpaceNoWrap?: boolean;
}

function CheckboxLabel({
  name,
  checked,
  onChange,
  label,
  whiteSpaceNoWrap = false,
}: CheckboxLabelProps) {
  return (
    <label className="flex items-center gap-2 cursor-pointer">
      <input
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="w-4 h-4 accent-[#1A1A1A] rounded-none"
      />
      <span
        className={`font-['Poppins'] not-italic font-normal text-[11px] lg:text-xs leading-[16px] text-[#434343]${
          whiteSpaceNoWrap ? " whitespace-nowrap" : ""
        }`}
      >
        {label}
      </span>
    </label>
  );
}

export default CheckboxLabel;

